/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../common/workflow/ui_elements/common';
import '../common/workflow/screens/form_screen';
import '../common/workflow/screens/completion_status_screen';
import '../common/workflow/screens/unit_notification_preferences_screen';
import '../common/workflow/screens/onboarding';
import '../spos/debitcard_management/atm_limits/debitcard_atm_limits';
import '../common/workflow/screens/headless_completion_screen';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "ScreenContainer": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "logEvent": {
                        "type": ".squareup.bbfrontend.service.v1.LogEvent",
                        "id": 2,
                        "rule": "optional"
                      },
                      "header": {
                        "type": ".squareup.bbfrontend.service.v1.ScreenHeader",
                        "id": 3,
                        "rule": "optional"
                      },
                      "formScreen": {
                        "type": ".squareup.bbfrontend.service.v1.FormScreen",
                        "id": 4
                      },
                      "completionStatusScreen": {
                        "type": ".squareup.bbfrontend.service.v1.CompletionStatusScreen",
                        "id": 5
                      },
                      "unitNotificationPreferencesScreen": {
                        "type": ".squareup.bbfrontend.service.v1.UnitNotificationPreferencesScreen",
                        "id": 6
                      },
                      "onboardingScreen": {
                        "type": ".squareup.bbfrontend.service.v1.OnboardingScreen",
                        "id": 7
                      },
                      "atmLimitsScreen": {
                        "type": ".squareup.bbfrontend.spos.debitcard_management.atm_limits.DebitCardATMLimitsScreen",
                        "id": 8
                      },
                      "headlessCompletionScreen": {
                        "type": ".squareup.bbfrontend.service.v1.HeadlessCompletionScreen",
                        "id": 9
                      }
                    },
                    "nested": {
                      "child": {
                        "oneof": ["formScreen", "completionStatusScreen", "unitNotificationPreferencesScreen", "onboardingScreen", "atmLimitsScreen", "headlessCompletionScreen"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ScreenContainer) {
  $root.addJSON(jsonData);
}

/**
 * Screen container represents the page that the clients would display. The screen container will
 * host [UiElement]s that are necessary to render the UI screen.
 *
 * SOURCE ScreenContainer @ squareup/bbfrontend/v1/model.proto at 22:1
 */
export const ScreenContainer = $root.lookupType('squareup.bbfrontend.service.v1.ScreenContainer');
fixType(ScreenContainer, {
  id: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ScreenContainer);